var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/index.js",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { showBlog } from '../../../../helpers/languageHelpers';
import SMHeaderContext from '../../SMHeaderContext';
import { NavBarContext } from './NavBarAnonContext';
import { ProductMenu } from './ProductsMenu.js';
import { SolutionsMenu } from './SolutionsMenu.js';
import { ResourcesMenu } from './ResourcesMenu.js';
import { PlansAndPricingMenu } from './PlansAndPricingMenu.js';
import { HelpCenterMenu } from './HelpCenterMenu.js';
var NavBarAnon = function NavBarAnon(_ref) {
  var color = _ref.color;
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang,
    isMRX = _useContext.isMRX;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    submenuOpened = _useState2[0],
    setOpen = _useState2[1];
  var toggleSubmenu = function toggleSubmenu(key) {
    if (submenuOpened === key) setOpen('');else setOpen(key);
  };
  return /*#__PURE__*/React.createElement(NavBarContext, {
    color: color,
    submenuOpened: submenuOpened,
    toggleSubmenu: toggleSubmenu,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sm-header__nav--anon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ProductMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(SolutionsMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), showBlog(lang) ? /*#__PURE__*/React.createElement(ResourcesMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 27
    }
  }) : null, !showBlog(lang) ? /*#__PURE__*/React.createElement(HelpCenterMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 28
    }
  }) : null, !isMRX ? /*#__PURE__*/React.createElement(PlansAndPricingMenu, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 19
    }
  }) : null));
};
NavBarAnon.propTypes = {
  color: PropTypes.oneOf(['secondary', 'alt'])
};
NavBarAnon.defaultProps = {
  color: 'secondary'
};
export default NavBarAnon;
//# sourceMappingURL=index.js.map